import { Button, Drawer, Table } from "antd";
import moment from "moment";
import React from "react";

const AuditReportDrawer = ({ open, onClose }) => {
  const data = [
    {
      reportName: "Safety Compliance",
      status: "In Progess",
      progress: "75%",
      dueDate: moment("03/18/25"),
    },
    {
      reportName: "HR Training",
      status: "Completed",
      progress: "100%",
      dueDate: moment("03/15/25"),
    },
    {
      reportName: "Financial Audit",
      status: "Overdue",
      progress: "75%",
      dueDate: moment("03/12/25"),
    },
    {
      reportName: "IT Security Review",
      status: "Pending",
      progress: "50%",
      dueDate: moment("03/10/25"),
    },
    {
      reportName: "Data Privacy Check",
      status: "In Progess",
      progress: "75%",
      dueDate: moment("03/05/25"),
    },
  ];

  const column = [
    {
      title: "REPORT NAME",
      dataIndex: "reportName",
      key: "reportName",
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "PROGRESS",
      dataIndex: "progress",
      key: "progress",
    },
    {
      title: "DUE DATE",
      dataIndex: "dueDate",
      key: "dueDate",
      render: (t) => <span>{moment(t).format("MM/DD/YY")}</span>,
    },

    {
      title: "ACTIONS",
      dataIndex: "action",
      key: "action",
      render: (t) => (
        <div className="actions-btn-parent">
          <Button type="text">View</Button>
        </div>
      ),
    },
  ];
  return (
    <Drawer
      title="Audit Report"
      placement="right"
      onClose={onClose}
      open={open}
      width={1080}
      className="audit-report-drawer"
    >
      <div className="drawer-content">
        <Table
          pagination={false}
          dataSource={data}
          columns={column}
          rowClassName={(_, index) =>
            index % 2 === 1 ? "altRow" : "normalRow"
          }
          className="auditScoreTable"
          scroll={{ x: true }}
        />
      </div>
    </Drawer>
  );
};

export default AuditReportDrawer;
